import type { RouteObject } from 'react-router';

/**
 * `/feeds` (019 AC-06). One lazy chunk holding one screen — the curated Tracks menu with per-feed
 * format pickers and copyable URLs, reached from the settings surface (never the sidebar). No props:
 * the page reads the practitioner's own tokens and containers.
 */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./feeds-page')).default }) },
];
